// extracted by mini-css-extract-plugin
export default {"button":"ShowBanners_button__RN9Ap","hidden":"ShowBanners_hidden__LhVzn","next":"ShowBanners_next__zljVZ","prev":"ShowBanners_prev__IxjXE"};